import { memo } from 'react';

import cn from '../../utils/cn';

const Table = ({ className, children, style }: React.HTMLAttributes<HTMLTableElement>) => {
  return (
    <table className={cn('box-border w-full caption-bottom border-collapse  text-sm', className)} style={style}>
      {children}
    </table>
  );
};

Table.displayName = 'Table';

export default memo(Table);
